import { useMemo, useState } from 'react';

export const useDashboardGridLayout = () => {
  const [layout, setLayout] = useState({ height: 0, width: 0 });

  const grid_dimensions = useMemo(
    () => ({ width: layout.width / 12, height: layout.height / 12 }),
    [layout]
  );

  return {
    layout,
    grid_dimensions,
    setLayout,
  };
};
